// 사이트 전체에서 쓰는 페이지 목록과 연락처 설정.
// 연락처·상담 링크를 바꿀 때는 이 파일만 고치면 됩니다.

export const SITE_URL = "https://www.inbathailand.com";

export const CONTACT = {
  email: "info@inbathailand.com",
  phoneThailand: { label: "+66 92 666 0155", tel: "+66926660155" },
  phoneKorea: { label: "+82 31 8067 6603", tel: "+823180676603" },
  // ── 카카오톡 상담 ── 아래 둘 중 하나를 채우면 됩니다(둘 다 있으면 링크 우선).
  //  - kakaoChatUrl: 카카오톡 채널(https://pf.kakao.com/...) 또는 오픈채팅(https://open.kakao.com/o/...) 주소
  //  - kakaoQrImage: QR 이미지를 public/assets/img/common/ 에 넣고 경로를 적기 (예: "/assets/img/common/kakao-qr.png")
  //    → 버튼을 누르면 QR 이 크게 뜹니다(PC 방문자가 휴대폰으로 찍는 용도).
  //  둘 다 비어 있으면 버튼을 눌렀을 때 '준비 중' 안내가 뜹니다.
  kakaoChatUrl: "",
  kakaoQrImage: "",
  // ── LINE 상담 ── 사용 방법은 카카오와 같습니다.
  // 지금 값은 디자인 시안의 담당자 명함 ID 기반 주소이고 실제 접속은 확인하지 못했습니다.
  // LINE 공식 계정(https://lin.ee/...) 주소로 바꾸는 것을 권장합니다.
  lineChatUrl: "https://line.me/ti/p/~lkb0815",
  lineQrImage: "",
  // ── 문의 폼 웹 접수 (Web3Forms, 무료) ──
  // https://web3forms.com 에서 info@inbathailand.com 을 넣으면 Access Key 가 메일로 옵니다.
  // 그 값을 아래 따옴표 안에 넣고 배포하면 문의가 info@inbathailand.com 으로 바로 접수됩니다.
  // (이 키는 화면 코드에 넣도록 만들어진 공개용이라 여기에 적어도 됩니다.) 비어 있으면 방문자의 메일 앱을 엽니다.
  // 주의: 이 사이트 코드에서 process.env 를 읽으면 Vercel 배포 정보(커밋 메시지 등)가 공개 JS에 같이 들어가니 쓰지 마세요.
  inquiryFormKey: "",
};

// key 는 페이지 CSS 범위(<html data-ib-page="key">)와 body 클래스(ib-p-key)에 쓰입니다.
export const PAGES = [
  {
    key: "home",
    path: "/",
    label: "HOME",
    title: "INBA Thailand | Korea × Thailand",
    description:
      "INBA (Thailand)는 한국 기업과 공공기관의 태국 시장 진출을 수입·유통, 디지털 마케팅, 전시·행사 현장 실행으로 연결합니다.",
    themeColor: "#0C2040",
  },
  {
    key: "about",
    path: "/about",
    label: "ABOUT INBA",
    title: "ABOUT INBA | INBA Thailand",
    description:
      "INBA Thailand — 한국과 태국의 전문성을 연결해 시장 진출, 유통, 디지털 마케팅, 전시·행사를 실행합니다.",
    themeColor: "#ffffff",
  },
  {
    key: "business",
    path: "/business",
    label: "BUSINESS",
    title: "BUSINESS | INBA Thailand",
    description: "INBA Thailand: TRADE, DIGITAL, EVENTS — 사업 서비스 및 수행 경험",
    themeColor: "#ffffff",
  },
  {
    key: "portfolio",
    path: "/portfolio",
    label: "PORTFOLIO",
    title: "PORTFOLIO | INBA Thailand",
    description: "INBA Thailand의 태국 시장 진출, 디지털 마케팅, 전시·행사 수행 프로젝트 18건",
    themeColor: "#ffffff",
  },
  {
    key: "brands",
    path: "/brands",
    label: "OUR BRANDS",
    title: "OUR BRANDS | INBA Thailand",
    description: "INBA Thailand — Hello-K와 Enjoy Live-K 두 전문 플랫폼을 소개합니다.",
    themeColor: "#ffffff",
  },
  {
    key: "contact",
    path: "/contact",
    label: "CONTACT",
    title: "CONTACT | INBA Thailand",
    description: "INBA Thailand CONTACT — 한국과 태국 사무실, 지도, 비즈니스 상담 및 이메일 문의",
    themeColor: "#ffffff",
  },
];

export const NOT_FOUND_PAGE = {
  key: "notfound",
  path: null,
  label: "",
  title: "페이지를 찾을 수 없습니다 | INBA Thailand",
  description: PAGES[0].description,
  themeColor: "#ffffff",
};

export function findPage(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";
  return PAGES.find((p) => p.path === clean) || NOT_FOUND_PAGE;
}
